const slovenianAnimals = {
  // fallback
  "animal.kindCount.generic": "{{count}} žival",
  "animal.kindCount.generic_one": "{{count}} žival",
  "animal.kindCount.generic_two": "{{count}} živali",
  "animal.kindCount.generic_few": "{{count}} živali",
  "animal.kindCount.generic_other": "{{count}} živali",

  // SPECIES NO GENDER AGE GROUP
  "animal.kindCount.PRASIC.ODRASEL": "{{count}} prašič",
  "animal.kindCount.PRASIC.ODRASEL_one": "{{count}} prašič",
  "animal.kindCount.PRASIC.ODRASEL_two": "{{count}} prašiča",
  "animal.kindCount.PRASIC.ODRASEL_few": "{{count}} prašiči",
  "animal.kindCount.PRASIC.ODRASEL_other": "{{count}} prašičev",

  "animal.kindCount.OVCA.ODRASEL": "{{count}} ovca",
  "animal.kindCount.OVCA.ODRASEL_one": "{{count}} ovca",
  "animal.kindCount.OVCA.ODRASEL_two": "{{count}} ovci",
  "animal.kindCount.OVCA.ODRASEL_few": "{{count}} ovce",
  "animal.kindCount.OVCA.ODRASEL_other": "{{count}} ovc",

  "animal.kindCount.KOZA.ODRASEL": "{{count}} koza",
  "animal.kindCount.KOZA.ODRASEL_one": "{{count}} koza",
  "animal.kindCount.KOZA.ODRASEL_two": "{{count}} kozi",
  "animal.kindCount.KOZA.ODRASEL_few": "{{count}} koze",
  "animal.kindCount.KOZA.ODRASEL_other": "{{count}} koz",

  "animal.kindCount.KONJ.ODRASEL": "{{count}} konj",
  "animal.kindCount.KONJ.ODRASEL_one": "{{count}} konj",
  "animal.kindCount.KONJ.ODRASEL_two": "{{count}} konja",
  "animal.kindCount.KONJ.ODRASEL_few": "{{count}} konji",
  "animal.kindCount.KONJ.ODRASEL_other": "{{count}} konjev",

  // SHEEP
  "animal.kindCount.sheep.cub": "{{count}} jagnje",
  "animal.kindCount.sheep.cub_one": "{{count}} jagnje",
  "animal.kindCount.sheep.cub_two": "{{count}} jagnjeti",
  "animal.kindCount.sheep.cub_few": "{{count}} jagnjeta",
  "animal.kindCount.sheep.cub_other": "{{count}} jagnjet",

  "animal.kindCount.sheep.adult.male": "{{count}} oven",
  "animal.kindCount.sheep.adult.male_one": "{{count}} oven",
  "animal.kindCount.sheep.adult.male_two": "{{count}} ovna",
  "animal.kindCount.sheep.adult.male_few": "{{count}} ovni",
  "animal.kindCount.sheep.adult.male_other": "{{count}} ovnov",

  "animal.kindCount.sheep.adult.female": "{{count}} ovca",
  "animal.kindCount.sheep.adult.female_one": "{{count}} ovca",
  "animal.kindCount.sheep.adult.female_two": "{{count}} ovci",
  "animal.kindCount.sheep.adult.female_few": "{{count}} ovce",
  "animal.kindCount.sheep.adult.female_other": "{{count}} ovc",

  // GOAT
  "animal.kindCount.goat.cub": "{{count}} kozlič",
  "animal.kindCount.goat.cub_one": "{{count}} kozlič",
  "animal.kindCount.goat.cub_two": "{{count}} kozliča",
  "animal.kindCount.goat.cub_few": "{{count}} kozliči",
  "animal.kindCount.goat.cub_other": "{{count}} kozličev",

  "animal.kindCount.goat.adult.male": "{{count}} kozel",
  "animal.kindCount.goat.adult.male_one": "{{count}} kozel",
  "animal.kindCount.goat.adult.male_two": "{{count}} kozla",
  "animal.kindCount.goat.adult.male_few": "{{count}} kozli",
  "animal.kindCount.goat.adult.male_other": "{{count}} kozlov",

  "animal.kindCount.goat.adult.female": "{{count}} koza",
  "animal.kindCount.goat.adult.female_one": "{{count}} koza",
  "animal.kindCount.goat.adult.female_two": "{{count}} kozi",
  "animal.kindCount.goat.adult.female_few": "{{count}} koze",
  "animal.kindCount.goat.adult.female_other": "{{count}} koz",

  // EQUINE
  "animal.kindCount.equine.cub": "{{count}} žrebe",
  "animal.kindCount.equine.cub_one": "{{count}} žrebe",
  "animal.kindCount.equine.cub_two": "{{count}} žrebeti",
  "animal.kindCount.equine.cub_few": "{{count}} žrebeta",
  "animal.kindCount.equine.cub_other": "{{count}} žrebet",

  "animal.kindCount.equine.adult.male": "{{count}} žrebec",
  "animal.kindCount.equine.adult.male_one": "{{count}} žrebec",
  "animal.kindCount.equine.adult.male_two": "{{count}} žrebca",
  "animal.kindCount.equine.adult.male_few": "{{count}} žrebci",
  "animal.kindCount.equine.adult.male_other": "{{count}} žrebcev",

  "animal.kindCount.equine.adult.female": "{{count}} kobila",
  "animal.kindCount.equine.adult.female_one": "{{count}} kobila",
  "animal.kindCount.equine.adult.female_two": "{{count}} kobili",
  "animal.kindCount.equine.adult.female_few": "{{count}} kobile",
  "animal.kindCount.equine.adult.female_other": "{{count}} kobil",

  // PIG
  "animal.kindCount.pig.cub": "{{count}} pujsek",
  "animal.kindCount.pig.cub_one": "{{count}} pujsek",
  "animal.kindCount.pig.cub_two": "{{count}} pujska",
  "animal.kindCount.pig.cub_few": "{{count}} pujski",
  "animal.kindCount.pig.cub_other": "{{count}} pujskov",

  "animal.kindCount.pig.adult.male": "{{count}} merjasec",
  "animal.kindCount.pig.adult.male_one": "{{count}} merjasec",
  "animal.kindCount.pig.adult.male_two": "{{count}} merjasca",
  "animal.kindCount.pig.adult.male_few": "{{count}} merjasci",
  "animal.kindCount.pig.adult.male_other": "{{count}} merjascev",

  "animal.kindCount.pig.adult.female": "{{count}} svinja",
  "animal.kindCount.pig.adult.female_one": "{{count}} svinja",
  "animal.kindCount.pig.adult.female_two": "{{count}} svinji",
  "animal.kindCount.pig.adult.female_few": "{{count}} svinje",
  "animal.kindCount.pig.adult.female_other": "{{count}} svinj",
};

export default slovenianAnimals;
